import React from "react";
import Link from "next/link";
import FadeInAnimation from "../Common/FadeInAnimation";
import { BiChevronRight, BiBuildingHouse, BiServer, BiLogoMicrosoft, BiDoorOpen } from "react-icons/bi";
import { useTranslations } from '../../locales/useTranslations';

const BusinessAnalyticsWeitereDienstleistungen = () => {
  const { t } = useTranslations();
  return (
    <>
      <div className="services-area ptb-70">
        <div className="container">
          <div className="section-title text-left">
            <span className="sub-title">{t("businessAnalytics_moreServices_subtitle")}</span>
            <h2>{t("businessAnalytics_moreServices_title")}</h2>
          </div>

          <FadeInAnimation direction="up" delay={100}>
            <div className="container">
              <div className="row">

                <div className="col-sm-6">
                  <Link href="/it-consulting" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiBuildingHouse />
                      </div>
                      <h3>{t("businessAnalytics_moreServices_itConsulting_title")}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t("businessAnalytics_moreServices_itConsulting_description") }} />
                      <span className="features-box-action">{t("businessAnalytics_moreServices_itConsulting_readMore")}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiBuildingHouse />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/kuenstliche-intelligenz/" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiServer />
                      </div>
                      <h3>{t("businessAnalytics_moreServices_ai_title")}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t("businessAnalytics_moreServices_ai_description") }} />
                      <span className="features-box-action">{t("businessAnalytics_moreServices_ai_readMore")}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiServer />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/business-analytics/power-bi" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiLogoMicrosoft />
                      </div>
                      <h3>{t("businessAnalytics_moreServices_powerBi_title")}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t("businessAnalytics_moreServices_powerBi_description") }} />
                      <span className="features-box-action">{t("businessAnalytics_moreServices_powerBi_readMore")}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiLogoMicrosoft />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/business-analytics/metabase" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiDoorOpen />
                      </div>
                      <h3>{t("businessAnalytics_moreServices_metabase_title")}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t("businessAnalytics_moreServices_metabase_description") }} />
                      <span className="features-box-action">{t("businessAnalytics_moreServices_metabase_readMore")}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiDoorOpen />
                      </div>
                    </div>
                  </Link>
                </div>

              </div>
            </div>
          </FadeInAnimation>

        </div>
      </div>
    </>
  );
};

export default BusinessAnalyticsWeitereDienstleistungen;
